import {Model} from "../../_model/Model";

export default class ModuleModel extends Model {

}
